export default __webpack_public_path__ + "static/media/pirs.bfd507fa.png";